<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-else>
      <div v-if="tabela">
        <div class="row">
          <div>
            <b-table
              responsive="sm"
              :items="dadosEmail"
              :fields="camposEmail"
              per-page="1000"
              striped
            >
              <template #cell(options)="data">
                <div class="d-flex justify-content-end">
                  <b-button
                    size="sm"
                    class="me-1"
                    variant="primary"
                    @click="editarEmail(data.item)"
                    data-tooltip="Editar"
                    data-tooltip-location="left"
                  >
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                  <b-button
                    size="sm"
                    class="me-1"
                    variant="danger"
                    @click="excluirEmail(data.item)"
                    data-tooltip="Excluir"
                    data-tooltip-location="left"
                  >
                    <i class="mdi mdi-trash-can"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
          <div>
            <div class="mt-1 d-flex justify-content-end">
              <b-button variant="info" class="mt-3 mb-3" @click="incluir()">
                <i class="mdi mdi-plus"></i>
                Incluir
              </b-button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="mt-1 d-flex justify-content-between">
            <b-button
              class="mt-1 me-1"
              @click="navegar('contatos', false)"
              data-tooltip="Voltar"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-arrow-left-circle font-size-15"></i>
            </b-button>
            <b-button
              variant="primary"
              class="mt-1"
              @click="navegar('infoBancarias', true)"
              data-tooltip="Próximo"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-arrow-right-circle font-size-15"></i>
            </b-button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row d-flex">
          <div class="col-md-8">
            <b-form-group
              class="mb-3 form-label"
              label="E-mail"
              invalid-feedback="Digite um E-mail válido"
            >
              <b-form-input
                v-model="ds_email"
                type="text"
                trim
                autocomplete="off"
                :state="verificarEmailCorreto(ds_email)"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label="Tipo E-mail">
              <multiselect
                v-model="selectTipoEmail"
                placeholder="Selecione"
                :show-labels="false"
                label="nm_tipo"
                :options="optionTipoEmail"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="m-auto">
            <b-form-checkbox
              v-model="st_principal"
              unchecked-value="N"
              value="S"
              plain
              :disabled="disabledPrincipal"
            >
              E-mail Principal
            </b-form-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="mt-1 d-flex justify-content-between">
            <b-button
              variant="secondary"
              data-tooltip="Voltar"
              data-tooltip-location="bottom"
              class="mt-1 me-1"
              @click="tabela = !tabela"
            >
              <i class="mdi mdi-arrow-left-circle font-size-15"></i>
            </b-button>
            <b-button
              variant="success"
              class="mt-1 me-1"
              @click="salvar"
              data-tooltip="Salvar"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-content-save"></i>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      tabela: true,
      ds_email: "",
      sq_mail: "",
      st_principal: "N",
      disabledPrincipal: false,
      dadosEmail: [],
      camposEmail: [
        {
          key: "ds_email",
          label: "E-mail",
        },
        {
          key: "cd_tipo",
          label: "Tipo E-mail",
          formatter: (value) => {
            var cdTipo = this.optionTipoEmail.find((el) => el.cd_tipo == value);
            return cdTipo ? cdTipo.nm_tipo : "";
          },
        },
        {
          key: "st_principal",
          label: "Principal",
          formatter: (value) => {
            return value == "S" ? "Sim" : "Não";
          },
        },
        {
          key: "options",
          label: "",
        },
      ],
      optionTipoEmail: [
        {
          cd_tipo: 1,
          nm_tipo: "Comercial",
        },
        {
          cd_tipo: 9,
          nm_tipo: "Particular",
        },
      ],
      selectTipoEmail: "",
      loading: true,
    };
  },
  async created() {
    await this.buscarEmail();
  },

  methods: {
    verificarEmailCorreto(email) {
      if (email.length === 0) {
        // o campo só ira pintar se tiver algo no input
        return null;
      }
      this.usuario = email.substring(0, email.indexOf("@"));
      this.dominio = email.substring(email.indexOf("@") + 1, email.length);

      if (
        this.usuario.length >= 1 &&
        this.dominio.length >= 3 &&
        this.usuario.search("@") == -1 &&
        this.dominio.search("@") == -1 &&
        this.usuario.search(" ") == -1 &&
        this.dominio.search(" ") == -1 &&
        this.dominio.search(".") != -1 &&
        this.dominio.indexOf(".") >= 1 &&
        this.dominio.lastIndexOf(".") < this.dominio.length - 1
      ) {
        this.$emit("emitindoEmail", this.email);
        return true;
      } else {
        if (email.length === 0) {
          // verificando novamente o input para pintar o campo
          return null;
        } else {
          // se já estiver com dados no input e não estiver válido ira pintar de vermelho
          return false;
        }
      }
    },

    async buscarEmail() {
      this.dadosEmail = [];
      try {
        const [respEmail] = await Promise.all([
          this.$http.get("api/profileErp/contatos"),
        ]);
        this.dadosEmail = (respEmail.data || []).filter(item => {
          if (item.TipoContato && item.TipoContato.TipoComunicacao === "E") return true;
          if (item.Descricao && item.Descricao.includes("@")) return true;
          return false;
        }).map(item => ({
          ...item,
          ds_email: item.Descricao || item.ds_email,
          sq_mail: item.Id || item.sq_mail,
          cd_tipo: item.IdTipoContato || item.cd_tipo,
          st_principal: item.Principal ? "S" : "N"
        }));
        this.tabela = true;
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },

    salvar() {
      if (
        this.verificarEmailCorreto(this.ds_email) &&
        this.selectTipoEmail != ""
      ) {
        this.loading = true;
        var item = {
          ds_email: this.ds_email,
          cd_tipo: this.selectTipoEmail.cd_tipo,
          st_principal: this.st_principal ? this.st_principal : "N",
          sq_mail: this.sq_mail,
          
          // Novos campos para portal_api
          IdTipoContato: this.selectTipoEmail.cd_tipo,
          Descricao: this.ds_email,
          Principal: this.st_principal === "S",
          Whatsapp: false
        };
        
        const isEdit = !!this.sq_mail;
        const url = isEdit ? `api/profileErp/contatos/${this.sq_mail}` : "api/profileErp/contatos";
        const requestAction = isEdit ? this.$http.put(url, item) : this.$http.post(url, item);

        requestAction
          .then(() => {
            this.$tools.alerta("E-mail cadastrado com sucesso", "success");
          })
          .catch((err) => {
            this.$tools.alerta(err.response.data.message, "error");
          })
          .finally(() => {
            this.loading = false;
            this.buscarEmail();
          });
      } else {
        this.loading = false;
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
      }
    },

    editarEmail(data) {
      this.ds_email = data.ds_email;
      this.selectTipoEmail = this.optionTipoEmail.find(
        (el) => el.cd_tipo == data.cd_tipo
      );
      this.sq_mail = data.sq_mail;
      this.st_principal = data.st_principal;
      this.disabledPrincipal = this.st_principal == "S" ? true : false;
      this.tabela = false;
    },

    excluirEmail(data) {
      if (data.st_principal === "S") {
        this.$tools.alerta(
          "Não é possível excluir um E-mail principal",
          "warning"
        );
        return;
      }
      this.loading = true;
      this.$http
        .delete(`api/profileErp/contatos/${data.sq_mail || data.Id}`)
        .then(() => {
          this.$tools.alerta("E-mail excluído com sucesso", "success");
          this.$emit("carregarNivelPerfil");
        })
        .catch((err) => {
          this.$tools.alerta(err.response.data.message, "error");
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
          this.buscarEmail(); // Chama a função buscarEmail independentemente de sucesso ou erro.
        });
    },

    incluir() {
      this.ds_email = "";
      this.sq_mail = null;
      (this.selectTipoEmail = ""), (this.st_principal = "");
      this.disabledPrincipal = false;
      this.tabela = false;
    },

    navegar(nomeAba, direcao) {
      this.$emit("navegar", nomeAba, direcao);
    },
  },
};
</script>